import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useCreateOrAppendCallTranscriptMutation as useCreateOrAppendCallTranscriptMutationType } from "@/modules/video-call/services/__generated__/useCreateOrAppendCallTranscriptMutation.graphql"

const createOrAppendCallTranscriptMutation = graphql`
  mutation useCreateOrAppendCallTranscriptMutation($input: CreateOrAppendCallTranscriptInput!) {
    createOrAppendCallTranscript(input: $input) {
      callTranscript {
        id
        roomId
        appointmentId
        progressNoteId
        transcript {
          id
          text
          timestamp
          isFinal
          speaker
        }
        callTranscriptStartedAt
        callTranscriptEndedAt
      }
      errors {
        ... on Error {
          __typename
          message
        }
      }
    }
  }
`

const useCreateOrAppendCallTranscriptMutation = () => {
  const [commit, isInFlight] = useMutation<useCreateOrAppendCallTranscriptMutationType>(
    createOrAppendCallTranscriptMutation,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCreateOrAppendCallTranscriptMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isInFlight] as const
}

export { useCreateOrAppendCallTranscriptMutation }
